import React, { useEffect, useState } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import ClearModalHeader from "@/components/ui/clear_modal_header";
import { Body, Link } from "@sprout/typography";
import useTranslation from "@hooks/use_translation";
import { PrimaryButton } from "@sprout/buttons";

const ClearConfirmationModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation("clear_verification");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isVerificationComplete = urlParams.get("verification_session_complete") === "true";

    if (isVerificationComplete) {
      setIsOpen(true);
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("verification_session_complete");
      window.history.replaceState({}, "", newUrl.toString());
    }
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md p-0 rounded-lg shadow-lg">
        <div className="px-6 pt-9">
          <ClearModalHeader className="mb-0" />
        </div>

        <div className="px-6">
          <Body medium className="!text-[18px]">
            {t("confirmation.title")}
          </Body>
        </div>

        <div className="px-6 mb-4">
          <Body className="text-base text-gray-900">
            {`${t("confirmation.message_intro")} ${t("confirmation.message_prefix")} `}
            <Link href="/account">{t("confirmation.account_profile")}</Link>.
          </Body>
        </div>

        <div className="flex justify-end px-6 pb-6">
          <PrimaryButton size="medium" onClick={() => setIsOpen(false)}>
            {t("confirmation.done")}
          </PrimaryButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClearConfirmationModal;
